import Vue from "vue";
import Vuex from "vuex";

import auth from "./auth.module";
import migModule from "./mig.module";
import partnerModule from "./partner.module";
import createPersistedState from "vuex-persistedstate";
import SecureLS from "secure-ls";
var ls = new SecureLS({
  isCompression: false
});
const debug = process.env.NODE_ENV !== "production";
Vue.use(Vuex);


export default new Vuex.Store({
  modules: {
    auth,
    migModule,
    partnerModule
  },
  /**
   * If strict mode should be enabled.
   */
  strict: debug,
  plugins: [
    createPersistedState({
      storage: {
        getItem: key => ls.get(key),
        setItem: (key, value) => ls.set(key, value),
        removeItem: key => ls.remove(key)
      }
    })
  ],
  secure: true,
  state: {},
  mutations: {},
  actions: {}
});